module.exports = __webpack_public_path__ + "static/media/BLUSH_6623.1d93463b.jpg";